export class ClientServerInfo<T = string> {
  constructor(private readonly client: T | null, private readonly server: T | null) {}

  getClient() {
    return this.client;
  }

  getServer() {
    return this.server;
  }
}
